export enum TicketFinancialType {
  Nonbillable = 0,
  Billable = 1,
}
